import { call, select } from 'redux-saga/effects';

import * as Actions from '../../../actions';
import { getInDomain } from '../../../domains/externalUtils';
import { putAndWait } from '../../../sagas/TaskManager';

const SKIP_BACK_TIME_LIMIT_SEC = 5;

export function* isPastSkipThreshold() {
  const currentTime = yield select(getInDomain('playback.utils.getCurrentPlaylistTrackTime'));
  return currentTime > SKIP_BACK_TIME_LIMIT_SEC;
}

export function* scrubTrackBack() {
  yield call(putAndWait, Actions.UseCases.scrubTrack({ value: 0 }));
}

export function* skipSourceBack({ payload: { index, sourceId } }) {
  yield call(
    putAndWait,
    getInDomain('playback.actions.skipItem')({
      sourceId,
      index,
      relativeIndex: -1,
    }),
  );
}
